import { memo, useMemo } from 'react';
import cn from 'classnames';
import { v4 } from 'uuid';

import styles from './TransferElements.module.scss';

interface ITransferElementsProps {
  className?: string;
  manyForward?: () => void;
  oneForward?: () => void;
  oneBackward?: () => void;
  manyBackward?: () => void;
  disableAll?: boolean;
}

export const TransferElements = memo(
  ({ className = '', manyForward, oneForward, oneBackward, manyBackward, disableAll }: ITransferElementsProps) => {
    const buttons = useMemo(
      () => [
        ...(manyForward
          ? [
              {
                onClickHandler: manyForward,
                iconClassName: styles.RightDoubleArrowIcon,
              },
            ]
          : []),
        {
          onClickHandler: oneForward,
          iconClassName: styles.RightArrowIcon,
        },
        {
          onClickHandler: oneBackward,
          iconClassName: styles.LeftArrowIcon,
        },
        ...(manyBackward
          ? [
              {
                onClickHandler: manyBackward,
                iconClassName: styles.LeftDoubleArrowIcon,
              },
            ]
          : []),
      ],
      [manyForward, oneForward, oneBackward, manyBackward],
    );

    return (
      <div className={cn(styles.TransferElements, className)}>
        {buttons.map(({ iconClassName, onClickHandler }) => (
          <button key={v4()} className={styles.Button} type="button" disabled={disableAll} onClick={onClickHandler}>
            <span className={iconClassName} />
          </button>
        ))}
      </div>
    );
  },
);
